import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, Subject, takeUntil } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { GlobalService } from '../helper/global-helper';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  private bearerToken: string | undefined;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private keycloak: KeycloakService, private global: GlobalService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.getToken();
    if (!request.headers.has('Authorization')) {
        request = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${this.bearerToken}`)
        });
    }
    if(!request.url.includes('sentrack')) {
      request = request.clone({
        withCredentials: true,
    });
    }
    if(request.url.includes('ipapi')) {
      request = request.clone({
        withCredentials: false,
    });
    }
    if(request.headers.has('skip-auth')) {
      request = request.clone({
        withCredentials: false,
    });
    }
    // add other custom headers
    return next.handle(request).pipe(takeUntil(this.global.onCancelPendingRequests()));
  }

  async getToken(){
    let token = await this.keycloak.getToken();
    this.bearerToken = token;
  }
}
